import * as utils from '@/utils/main_utils'
import axios from '@/utils/axios_iface'
import Vue from 'vue'

export default {
  state: {
    is_customer_logged_in: false,
    login_success_message: '',
    login_fail_message: '',
    login_in_progress: false,
    web_user: undefined,
    guest_user: undefined,
    otp_verification: {
      in_progress: false,
      sent: false,
      confirmed: false,
      progress_fail: false,
      error_message: '',
      confirmed_id: null,
      reference: '',
      mode: null,
    },
    varification_email_banner: false,
  },
  mutations: {
    AUTH_START(state) {
      state.login_success_message = ''
      state.login_fail_message = ''
      state.login_in_progress = true
    },
    AUTH_SUCCESS(state, token) {
      //data : token, user_status
      localStorage.setItem('token', token)
      axios.defaults.headers['Authorization'] = 'Bearer ' + token
      axios.defaults.headers['Accept'] = 'application/json'
      state.login_success_message = ''
      state.login_fail_message = ''
      state.login_in_progress = false
    },
    LOGOUT(state) {
      localStorage.removeItem('webuser_id')
      localStorage.removeItem('webuser_token')
      delete axios.defaults.headers['Authorization']
      state.is_customer_logged_in = false
      state.login_success_message = ''
      state.login_fail_message = ''
      state.login_in_progress = false
      window.OneSignal.push(function () {
        window.OneSignal.setExternalUserId(null)
      })
    },
    SET_LOGIN_SUCCESS_MESSAGE(state, message) {
      state.login_success_message = message
    },
    SET_LOGIN_FAILURE_MESSAGE(state, message) {
      state.login_fail_message = message
    },
    SET_LOGIN_IN_PROGRESS(state) {
      state.login_in_progress = true
    },
    UNSET_LOGIN_IN_PROGRESS(state) {
      state.login_in_progress = false
    },
    UPDATE_USER_NAME(state, data) {
      Vue.set(state.web_user, 'name', data)
    },
    UPDATE_USER_EMAIL(state, data) {
      Vue.set(state.web_user, 'email', data)
    },
    UPDATE_USER_PHONE(state, data) {
      Vue.set(state.web_user, 'phone_number', data)
    },
    SET_WEB_USER(state, web_user) {
      if (web_user.avatar === '' || web_user.avatar === null) {
        web_user.avatar = '/img/default_avatar.jpg'
      }
      state.web_user = web_user
      state.is_customer_logged_in = true
      localStorage.setItem('webuser_id', state.web_user.id)
      window.OneSignal.push(function () {
        window.OneSignal.setExternalUserId(state.web_user.id || null)
      })
      localStorage.setItem('webuser_token', state.web_user.webuser_token)
      axios.defaults.headers['WebuserId'] = state.web_user.id
      axios.defaults.headers['WebuserToken'] = state.web_user.webuser_token
    },
    SET_GUEST_USER(state, guest_user) {
      state.guest_user = guest_user
      localStorage.setItem('guest_user_id', state.guest_user.user_id)
    },
    RESET_WEB_USER(state) {
      state.web_user = undefined
    },
    UPDATE_USER_AVATAR(state, avatar) {
      if (avatar !== '' || avatar !== null) {
        Vue.set(state.web_user, 'avatar', avatar)
      }
    },
    SET_OTP_IN_PROGRESS(state) {
      state.otp_verification.in_progress = true
    },
    UNSET_OTP_IN_PROGRESS(state) {
      state.otp_verification.in_progress = false
    },
    SET_OTP_SENT(state) {
      state.otp_verification.sent = true
    },
    SET_OTP_CONFIRMED(state) {
      state.otp_verification.confirmed = true
    },
    SET_OTP_PROGRESS_FAIL(state, err) {
      state.otp_verification.progress_fail = true
      state.otp_verification.error_message = err
    },
    SET_CONFIRM_ID(state, ID) {
      state.otp_verification.confirmed_id = ID
    },
    SET_MODE_REFERENCE_DATA(state, data) {
      state.otp_verification.mode = data.mode
      state.otp_verification.reference = data.reference
    },
    RESET_OTP_PROGRESS(state) {
      state.otp_verification = {
        in_progress: false,
        sent: false,
        confirmed: false,
        progress_fail: false,
        error_message: '',
        confirmed_id: null,
        mode: null,
        reference: '',
      }
    },
    SET_EMAIL_BANNNER(state, status) {
      state.varification_email_banner = status
    },
  },
  actions: {
    login({ dispatch, commit, getters }, incoming_data = {}) {
      function process_error(e, reject) {
        commit('UNSET_LOGIN_IN_PROGRESS')
        if (e == null) {
          utils.process_error('Problem connecting to server')
          commit('SET_LOGIN_FAILURE_MESSAGE', 'Problem connecting to server')
        }
        reject()
      }

      return new Promise((resolve, reject) => {
        commit('AUTH_START')
        var headers = {
          WebuserId: localStorage.getItem('webuser_id') || '',
          WebuserToken: localStorage.getItem('webuser_token') || '',
          WebuserLogin: incoming_data.login || '',
          WebuserPassword: incoming_data.password || '',
          DomainName: location.hostname,
        }
        axios({
          url: getters.login_url,
          data: {
            email: process.env.VUE_APP_GUEST_EMAIL,
            password: process.env.VUE_APP_GUEST_PASSWORD,
          },
          headers: headers,
          method: 'POST',
        })
          .then((resp) => {
            let brand = resp.data.brand
            if (brand) {
              commit('SET_CURRENT_BRAND', brand)
              commit('SET_DOMAIN_BASED_BRAND', brand._id)
              // commit('SET_DOMAIN_BASED_BRAND', brand._id)
              commit('SET_DOMAIN_BASED_COLORS', brand)
              commit('SET_DOMAIN_BASED_CUSTOM_SETTINGS', brand)
              commit('SET_ONESIGNAL_SDK', brand)
              let currentCountry = localStorage.getItem('selectedCountry')
              if (currentCountry) {
                commit('SET_SELECTED_COUNTRY', currentCountry)
              }
            }
            commit('AUTH_SUCCESS', resp.data.token)
            if (resp.data.webuser) {
              commit('SET_WEB_USER', resp.data.webuser)
              // dispatch(
              //   'updateExternalHandler',
              //   'js-call:auth-status-change:' + (resp.data.webuser.id || null)
              // )
              dispatch('load_customer', true)
              resolve()
            } else if (incoming_data.email || incoming_data.password) {
              commit(
                'SET_LOGIN_FAILURE_MESSAGE',
                getters._T('Invalid credentials')
              )
              reject()
            } else {
              commit('SET_GUEST_USER', resp.data.user)

              resolve()
            }
          })
          .catch((e) => process_error(e, reject))
      })
    },

    register({ dispatch, commit, getters }, user) {
      var headers = {
        DomainName: location.hostname,
        DomainRoot: utils.getBaseUrl(),
      }
      function process_error(e, reject) {
        commit('SET_LOGIN_FAILURE_MESSAGE', e.response.data.error)
        commit('UNSET_LOGIN_IN_PROGRESS')
        reject()
      }
      return new Promise((resolve, reject) => {
        commit('SET_LOGIN_IN_PROGRESS')
        commit('SET_LOGIN_FAILURE_MESSAGE', '')
        commit('SET_LOGIN_SUCCESS_MESSAGE', '')
        axios({
          url: getters.register_web_user_url,
          data: user,
          headers: headers,
          method: 'POST',
        })
          .then((resp) => {
            if (resp.data.status != 'form_errors') {
              commit('AUTH_SUCCESS', resp.data.token)
              commit('SET_WEB_USER', resp.data.webuser)
              dispatch(
                'updateExternalHandler',
                'js-call:auth-status-change:' + (resp.data.webuser.id || null)
              )
              commit('RESET_OTP_PROGRESS')
            }
            resolve(resp)
          })
          .catch((e) => process_error(e, reject))
      })
    },

    logout({ dispatch, commit }) {
      return new Promise((resolve) => {
        commit('LOGOUT')
        commit('RESET_WEB_USER')
        dispatch('resetStoresStates')
        dispatch('updateExternalHandler', 'js-call:auth-status-change:null')
        dispatch('login').then(() => resolve())
      })
    },
    resetStoresStates({ dispatch, commit }) {
      dispatch('resetCollectionByCollectionId', 'goorder_customers')
      dispatch('resetCollectionByCollectionId', 'root_orders')
      dispatch('resetCustomerStoreStates')
      commit('SET_ORDER', {})
      commit('TRACKING_ORDER', {})
      commit('SET_CARD_MODEL', false)
    },
    set_login_failure_message({ dispatch, commit, getters }, data) {
      commit('SET_LOGIN_FAILURE_MESSAGE', data)
    },

    send_password_recovery_letter({ commit, getters }, payLoad) {
      commit('AUTH_START')
      var headers = {
        DomainName: location.hostname,
        DomainRoot: utils.getBaseUrl(),
      }
      axios({
        url: getters.forgot_pass_url,
        data: payLoad,
        method: 'POST',
        headers,
      })
        .then((resp) => {
          commit('UNSET_LOGIN_IN_PROGRESS')
          commit('SET_LOGIN_SUCCESS_MESSAGE', resp.data['message'])
        })
        .catch((err) => {
          commit('UNSET_LOGIN_IN_PROGRESS')
          commit('SET_LOGIN_FAILURE_MESSAGE', err.response.data['message'])
          utils.process_warning(
            'Reset Password: ' + err.response.data['message']
          )
        })
    },

    new_password_confirm({ commit, getters }, data) {
      return new Promise((resolve, reject) => {
        commit('AUTH_START')
        var headers = {
          DomainName: location.hostname,
          DomainRoot: utils.getBaseUrl(),
        }
        axios({
          url: getters.reset_pass_url,
          data,
          method: 'POST',
          headers,
        })
          .then((resp) => {
            commit('UNSET_LOGIN_IN_PROGRESS')
            resolve(resp)
          })
          .catch((err) => {
            commit('UNSET_LOGIN_IN_PROGRESS')
            commit('SET_LOGIN_FAILURE_MESSAGE', err.response.data['message'])
            utils.process_warning(
              'Reset Password: ' + err.response.data['message']
            )
            reject(err.response.data['message'])
          })
      })
    },

    update_user_avatar_name({ commit, getters }, data) {
      return new Promise((resolve, reject) => {
        axios({
          url:
            getters.customerAPI +
            getters.web_user.id +
            '/edit_user_avatar_name',
          data: { avatar: data.avatar, name: data.name },
          method: 'POST',
        })
          .then((resp) => {
            commit('UPDATE_USER_AVATAR', data.avatar)
            commit('UPDATE_USER_NAME', data.name)
            resolve(resp)
          })
          .catch((err) => {
            utils.process_warning(
              'Avatar Upload Fails: ' + err.response.data['message']
            )
            reject(err.response.data['message'])
          })
      })
    },
    update_user_email({ commit, getters }, data) {
      return new Promise((resolve, reject) => {
        axios({
          url: getters.customerAPI + getters.web_user.id + '/edit_user_email',
          data: {
            email: data.email.toString().toLowerCase(),
            confirm_password: data.confirm_password,
            email_verified: data.email_verified,
          },
          method: 'POST',
        })
          .then((resp) => {
            //TODO MAKE PROPER ERROR CATCH
            if (resp.data.status === 'ok') {
              commit('UPDATE_USER_EMAIL', data.email)
              resolve(resp)
            } else {
              utils.process_warning(getters._T('User Email Change ERROR'))
              reject(getters._T('User Email Change ERROR'))
            }
          })
          .catch((err) => {
            utils.process_warning(
              'User Email Change Warning: ' + err.response.data['message']
            )
            reject(err.response.data['message'])
          })
      })
    },
    edit_user_phone({ commit, getters }, data) {
      return new Promise((resolve, reject) => {
        axios({
          url: getters.customerAPI + getters.web_user.id + '/edit_user_phone',
          data: {
            phone_number: data.phone_number,
            confirm_password: data.confirm_password,
            phone_number_verified: data.phone_number_verified,
          },
          method: 'POST',
        })
          .then((resp) => {
            //TODO MAKE PROPER ERROR CATCH
            if (resp.data.status === 'ok') {
              commit('UPDATE_USER_PHONE', data.phone_number)
              resolve(resp)
            } else {
              utils.process_warning('User Email Change ERROR')
              reject('User Phone Number Change ERROR')
            }
          })
          .catch((err) => {
            utils.process_warning(
              'User Phone Number Change Warning: ' +
                err.response.data['message']
            )
            reject(err.response.data['message'])
          })
      })
    },
    edit_user_password({ commit, getters }, data) {
      return new Promise((resolve, reject) => {
        axios({
          url:
            getters.customerAPI + getters.web_user.id + '/edit_user_password',
          data: {
            confirm_password: data.confirm_password,
            password: data.password,
            repeat_new_password: data.repeat_new_password,
          },
          method: 'POST',
        })
          .then((resp) => {
            resolve(resp)
          })
          .catch((err) => {
            utils.process_warning(
              'Change Password fails: ' + err.response.data['message']
            )
            reject(err.response.data['message'])
          })
      })
    },

    sendOTP({ commit, getters }, data) {
      commit('RESET_OTP_PROGRESS')
      commit('SET_MODE_REFERENCE_DATA', {
        mode: data.mode,
        reference: data.reference,
      })
      function process_error(e, reject) {
        commit('UNSET_OTP_IN_PROGRESS')
        commit('SET_OTP_PROGRESS_FAIL', e)
        reject()
      }
      var headers = {
        DomainName: location.hostname,
        DomainRoot: utils.getBaseUrl(),
      }
      return new Promise((resolve, reject) => {
        commit('SET_OTP_IN_PROGRESS')
        var formData = {}
        formData[data.mode] = data.reference
        axios({
          url: getters.send_otp_url,
          data: formData,
          method: 'POST',
          headers,
        })
          .then((resp) => {
            resolve(resp)
          })
          .catch((e) => process_error(e, reject))
      })
    },

    confirmOTP({ commit, getters }, code) {
      function process_error(e, reject) {
        commit('UNSET_OTP_IN_PROGRESS')
        commit('SET_OTP_PROGRESS_FAIL', e)
        reject()
      }
      var formData = {}
      formData[getters.otp_progress_mode] = getters.otp_progress_reference
      formData['code'] = code
      var headers = {
        DomainName: location.hostname,
        DomainRoot: utils.getBaseUrl(),
      }
      return new Promise((resolve, reject) => {
        commit('SET_OTP_IN_PROGRESS')
        axios({
          url: getters.confirm_otp_url,
          data: formData,
          method: 'POST',
          headers,
        })
          .then((resp) => {
            if (resp.data.status == 'form_errors') {
              process_error(
                resp.data.form_errors[getters.otp_progress_mode],
                reject
              )
            } else {
              commit('UNSET_OTP_IN_PROGRESS')
              commit('SET_OTP_CONFIRMED')
              commit('SET_CONFIRM_ID', resp.data._id)
            }
            resolve(resp)
          })
          .catch((e) => process_error(e, reject))
      })
    },
  },
  getters: {
    is_web_admin: (state) =>
      state.web_user ? state.web_user.is_web_admin : false,
    login_success_message: (state) => state.login_success_message,
    login_fail_message: (state) => state.login_fail_message,
    login_in_progress: (state) => state.login_in_progress,
    is_customer_logged_in: (state) => state.is_customer_logged_in,
    userName: (state) => (state.web_user ? state.web_user['name'] : ''),
    userAvatar: (state) => (state.web_user ? state.web_user['avatar'] : ''),
    web_user: (state) => (state.web_user ? state.web_user : undefined),
    otp_verification: (state) => state.otp_verification,
    otp_progress: (state) => state.otp_verification.in_progress,
    otp_progress_fail: (state) => state.otp_verification.progress_fail,
    // otp_confirmed: state => state.otp_verification.confirmed_id,
    otp_confirmed: () => true,

    otp_progress_mode: (state) => state.otp_verification.mode,
    otp_progress_reference: (state) => state.otp_verification.reference,
    varification_email_banner: (state) => state.varification_email_banner,
    guest_user: (state) => state.guest_user,
  },
}
